import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PackLimitationsService } from '../shared/services/pack-limitations.service';

@Injectable({
  providedIn: 'root',
})
export class ClientFilterGuard implements CanActivate {
  private packLimitationService = inject(PackLimitationsService);

  canActivate() {
    return this.packLimitationService.canFilterClient() ?? false;
  }
}
